export type TravelpayoutsAccount = {
  marker: string;
  trs: string;
  programme: string | null;
  campaignId: string | null;
  searchUrl: string;
  searchParam: string;
};

type PartnerAccounts = {
  booking_com: { cjWebsiteId: string; cjLinkId: string };
  agoda: { cid: string };
  expedia: { cjWebsiteId: string; cjLinkId: string | null };
  getyourguide: { partnerId: string };
  viator: { pid: string; mcid: string };
  tiqets: TravelpayoutsAccount;
  klook: TravelpayoutsAccount;
  kkday: TravelpayoutsAccount;
};

export type BookingPartnerKey = keyof PartnerAccounts;

export type BookingPartner = {
  [K in BookingPartnerKey]: {
    key: K;
    name: string;
    covers: 'hotel' | 'activity';
    route: 'direct' | 'cj' | 'travelpayouts';
    enabled: boolean;
    account: Readonly<PartnerAccounts[K]>;
  };
}[BookingPartnerKey];

const BookingPartner: readonly BookingPartner[] = Object.freeze([
  {
    key: 'booking_com',
    name: 'Booking.com',
    covers: 'hotel',
    route: 'cj',
    enabled: true,
    account: { cjWebsiteId: '101638254', cjLinkId: '15734754' },
  },
  {
    key: 'agoda',
    name: 'Agoda',
    covers: 'hotel',
    route: 'direct',
    enabled: true,
    account: { cid: '1967939' },
  },
  {
    key: 'expedia',
    name: 'Expedia',
    covers: 'hotel',
    route: 'cj',
    enabled: false,
    account: { cjWebsiteId: '101638254', cjLinkId: null },
  },
  {
    key: 'getyourguide',
    name: 'GetYourGuide',
    covers: 'activity',
    route: 'direct',
    enabled: true,
    account: { partnerId: 'QKOGDNW' },
  },
  {
    key: 'viator',
    name: 'Viator',
    covers: 'activity',
    route: 'direct',
    enabled: true,
    account: { pid: 'P00307644', mcid: '42383' },
  },
  {
    key: 'tiqets',
    name: 'Tiqets',
    covers: 'activity',
    route: 'travelpayouts',
    enabled: true,
    account: {
      marker: '744771',
      trs: '577592',
      programme: '2074',
      campaignId: '89',
      searchUrl: 'https://www.tiqets.com/en/search',
      searchParam: 'q',
    },
  },
  {
    key: 'klook',
    name: 'Klook',
    covers: 'activity',
    route: 'travelpayouts',
    enabled: true,
    account: {
      marker: '744771',
      trs: '577592',
      programme: '4110',
      campaignId: '137',
      searchUrl: 'https://www.klook.com/en-GB/search/',
      searchParam: 'query',
    },
  },
  {
    key: 'kkday',
    name: 'KKday',
    covers: 'activity',
    route: 'travelpayouts',
    enabled: true,
    account: {
      marker: '744771',
      trs: '577592',
      programme: '9074',
      campaignId: '633',
      searchUrl: 'https://www.kkday.com/en/product/productlist',
      searchParam: 'keyword',
    },
  },
]);

export default BookingPartner;
